import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import './CheckBoxGroup.scss'

interface CheckBoxItem {
  name: string
  label: string
  localizationKey?: string
}

interface Props {
  header?: ReactNode
  footer?: ReactNode
  items: CheckBoxItem[]
  checked: (key: string) => boolean
  setChecked: (key: string) => void
}

function CheckBoxGroup({ footer, header, items, checked, setChecked }: Props) {
  return (
    <div className='checkbox-group' onClick={e => e.stopPropagation()}>
      {header && <div className='checkbox-group__header'>{header}</div>}
      <div className='checkbox-group__items'>
        {items?.map((item, index) => {
          const { name, label, localizationKey } = item
          return (
            <div className='checkbox-group__item' key={index}>
              <span>{tr(localizationKey, label)}</span>
              <span
                className={cn('checkbox', { checked: checked(name) })}
                onClick={() => setChecked(name)}
                data-test={`toggle-${name}`}
              />
            </div>
          )
        })}
      </div>
      {footer && <div className='checkbox-group__footer'>{footer}</div>}
    </div>
  )
}

export default CheckBoxGroup
